<template>
    <div>
      <buttons-group
          :items="items"
          :disabledAll="true"
          :indexStep="index"
          :width="270"
          @click="getIndex"
      />
    </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

export default {
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      items: [
        'Relatórios',
        'Lista de E-mails',
        'Etiquetas'
      ],
      role: jwtDecode(localStorage.getItem('tokenBearer')).role
    }
  },
  methods: {
    getIndex (index) {
      this.$emit('changeAll', { tabName: this.getTabName(index), index })
    },
    getTabName (tab) {
      return this.items[tab]
    },
    isAdminBrasil () {
      return (this.role === 'admin_brasil')
    }
  }
}
</script>
